import React from 'react';
const LIGHT_BG_LOGO = 'https://cdn.magicpatterns.com/uploads/fGzNMRJgNv1xLJWExUJ7pA/viva-brezice-logo-light.svg';
const DARK_BG_LOGO = 'https://cdn.magicpatterns.com/uploads/cAXtc3Pyb1UduhJELkQDsn/viva-brezice-logo-dark.svg';
interface LogoProps {
  /** "light" = za svetle podlage, "dark" = za temne/zelene podlage */
  variant?: 'light' | 'dark';
  className?: string;
}
export function Logo({
  variant = 'light',
  className = 'h-10'
}: LogoProps) {
  return <img src={variant === 'light' ? LIGHT_BG_LOGO : DARK_BG_LOGO} alt="MEPZ VIVA Brežice" className={`w-auto ${className}`} data-id="element-441" data-mp="it233x3fo8fk" />;
}

/** Subtilni motiv petih valovitih črt iz logotipa. */
export function Waves({
  className = '',
  color = '#007c69',
  opacity = 0.16
}: {
  className?: string;
  color?: string;
  opacity?: number;
}) {
  return <svg viewBox="0 0 480 120" fill="none" aria-hidden="true" preserveAspectRatio="none" className={className} style={{
    opacity
  }} data-id="element-442" data-mp="23aq8nl7cojlf">
      {[0, 1, 2, 3, 4].map(i => <path key={i} d={`M0 ${18 + i * 21} C 90 ${4 + i * 21}, 150 ${34 + i * 21}, 240 ${20 + i * 21} S 400 ${2 + i * 21}, 480 ${16 + i * 21}`} stroke={color} strokeWidth="1.5" strokeLinecap="round" data-id="element-443" data-mp="1e6ejkwiulss0" />)}
    </svg>;
}